<template>
  <div class="picklist">
    <div class="row margin">
      <div class="margin"></div>
      <div class="col-md-6 col-sm-12"><h3>Packliste <small>{{'date' | translate($parent.language)}}: {{new Date() | orderDate}}</small></h3></div>
      <div class="col-md-6 col-sm-12 text-right"><button class="btn btn-app" onclick="javascript:print(window)"><i class="fa fa-print"></i>Drucken</button></div>
    </div>
    <div class="row margin">
      <div class="col-md-3 col-sm-4">
        <multiselect :options="stores" label="label" track-by="name" placeholder="Hersteller wählen..." v-model="selectedStore" @close="filter()"></multiselect>
      </div>
      <div class="col-md-3 col-sm-4">
        <select class="form-control" v-model="sortType" @change="sortArticle('article_number')">
          <option value="">Sortierung</option>
          <option value="asc">Artikelnummer aufsteigend</option>
          <option value="desc">Artikelnummer absteigend</option>
        </select>
      </div>
      <div class="col-md-3 col-sm-4">
        <select class="form-control" v-model="status">
          <option value="">Status</option>
          <option value="initial">{{'initial' | translate | capitalize}}</option>
          <option value="approved">{{'approved' | translate | capitalize}}</option>
        </select>
      </div>
    </div>
    <div class="row margin">
      <div class="col-xs-12">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th width="80">Bild</th>
            <th>Status</th>
            <th @click="makeSort">Filale <i :class="clicked ? 'fa fa-caret-up ml-5' : 'fa fa-caret-down ml-5' "></i></th>
            <th>Bestellung</th>
            <th><i :class="['fa', `fa-sort-amount-${sortType}`, 'mr-5']"></i>Artikelnr.</th>
            <th>EAN</th>
            <th>Größe</th>
            <th width="25%">Artikel</th>
            <th>Preis</th>
            <th>Vermerk</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in filterData" v-if="status === '' || item.status === status">
            <td><img class="img-preview" :src="item.image_url"/></td>
            <td>{{item.status | translate}}</td>
            <td><strong>{{item.store_name}}</strong><br/>{{item.store_street}}<br/>{{item.store_city}}</td>
            <td>
              <strong>{{'date' | translate($parent.language)}}:</strong> {{item.order_date}} <br/>
              <strong>QB-ID:</strong> {{item.qb_id}} <br/>
              <strong>{{mps[item.sales_channel]}}-ID:</strong> {{item.ext_order_id}}
            </td>
            <td>{{item.article_number}}</td>
            <td>{{item.ean}}</td>
            <td>{{item.size}}</td>
            <td width="25%">{{item.title}}</td>
            <td>{{item.item_price}}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row margin">
      <div class="col-xs-12 text-right"><button class="btn btn-app" onclick="javascript:print(window)"><i class="fa fa-print"></i>Drucken</button></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PicklistView',
  data () {
    return {
      list: [],
      filterData: [],
      selectedStore: {label: 'Alle'},
      sortType: '',
      selectedSorting: '',
      status: 'approved',
      stores: [{label: 'Alle'}],
      clicked: false,
      mps: ['none', 'schuhe.de', 'eBay', 'Zalando', 'Amazon']
    }
  },
  methods: {
    makeSort () {
      if (this.clicked) {
        this.list.reverse()
      } else {
        this.selectedSorting = 'store_name'
        this.list.sort(this.compare)
      }
      this.clicked = !this.clicked
    },
    sortArticle (key) {
      this.selectedSorting = key
      if (this.sortType !== '') {
        this.filterData.sort(this.compare)
        if (this.sortType === 'desc') {
          this.filterData.reverse()
        }
      }
    },
    compare (a, b) {
      if (a[this.selectedSorting] < b[this.selectedSorting]) {
        return -1
      }
      if (a[this.selectedSorting] > b[this.selectedSorting]) {
        return 1
      }
      return 0
    },
    getStores () {
      this.list.forEach(s => {
        if (!this.stores.find(e => { return e.store_number === s.store_number })) {
          this.stores.push({name: s.store_name, store_number: s.store_number, label: `${s.store_number}${(s.store_erp_id !== '' ? ` - ${s.store_erp_id}` : '')} - ${s.store_name} - ${s.store_city}`, erp_id: s.store_erp_id, city: s.store_city})
        }
      })
    },
    filter () {
      if (this.selectedStore.label !== 'Alle') {
        this.filterData = this.list.filter(el => {
          return el.store_number === this.selectedStore.store_number
          //let regex = new RegExp(this.escapeRegExp(this.selectedStore.name), 'i')
          //return el.store_name.match(regex)
        })
      } else {
        this.filterData = this.list
      }
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    }
  },
  mounted () {
    API.get('/orders/picklist')
      .then(response => {
        this.list = response.data
        this.filterData = response.data
        this.getStores()
      })
  }
}
</script>
<style type="text/css" media="print">
@page {
  size: landscape;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .multiselect, .multiselect__input, .multiselect__single, .multiselect--active {
    font-size: 14px !important;
    background: #cccccccc !important;
    color: black !important;
    z-index: 3 !important;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: black !important;
    background: #cccccccc !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 3 !important;
    -webkit-overflow-scrolling: touch;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/PicklistView.vue